import { type PayloadAction, createReducer } from '@reduxjs/toolkit';

import { setMedia } from './media.actions';
import { type IActionType, type MediaState, MediaTypes } from './media.types';

const INITIAL_STATE: MediaState = {
    isMobile: false,
    isPhone: false,
    isPhoneSmall: false,
    isTablet: false,
    isDesktop: false,
    isDesktopMedium: false,
    isDesktopSmall: false,
    windowWidth: 0,
};

export const mediaReducer = createReducer(INITIAL_STATE, {
    [setMedia.type]: (state, action: PayloadAction<IActionType>) => {
        return {
            ...INITIAL_STATE,
            isMobile:
                action.payload.type === MediaTypes.PHONE ||
                action.payload.type === MediaTypes.TABLET ||
                action.payload.type === MediaTypes.PHONE_SMALL,
            isPhone: action.payload.type === MediaTypes.PHONE || action.payload.type === MediaTypes.PHONE_SMALL,
            isPhoneSmall: action.payload.type === MediaTypes.PHONE_SMALL,
            isTablet: action.payload.type === MediaTypes.TABLET,
            isDesktop: action.payload.type === MediaTypes.DESKTOP_MEDIUM || action.payload.type === MediaTypes.DESKTOP_SMALL,
            isDesktopSmall: action.payload.type === MediaTypes.DESKTOP_SMALL,
            isDesktopMedium: action.payload.type === MediaTypes.DESKTOP_MEDIUM,
            windowWidth: action.payload.windowWidth,
        };
    },
});
